<template>
    <ModalContent>
        <template slot="title">
            <span class="primary--text">{{ content?.fields?.title }}</span>
        </template>
        <template slot="content">
            <ContentfulRichText
                v-if="content"
                :document="content?.fields?.helpText"
            />
            <div key="error" v-else-if="error">{{ error }}</div>
            <div key="loading" v-else-if="loading">
                <Loading :absolute="false" :size="200" />
            </div>
            <div key="notfound" v-else>{{ $translate('helpNotFound') }}</div>
        </template>
        <template slot="bottom">
            <Button
                class="my-2 my-sm-4 w-100 w-sm-auto ml-sm-3"
                :text="$translate('buttons.close')"
                @click="hideModal"
            />
        </template>
    </ModalContent>
</template>

<script>
import { mapActions } from "vuex";
import ContentfulRichText from "@/components/common/contentful-rich-text";

export default {
    components: {
        ContentfulRichText,
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            content: null,
            loading: false,
            error: null,
        };
    },
    async created() {
        this.loading = true;
        try {
            const content = await this.fetchContent(this.params.contentUniqueId);
            this.content = content;
        } catch (error) {
            this.error = error;
        } finally {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions("help", ["fetchContent"]),
        ...mapActions("mcl", ["hideModal"]),
    },
    i18n: {
        messages: {
            en: {
                helpNotFound: "Help not found.",
                buttons: {
                    close: "Close",
                },
            },
            fr: {
                helpNotFound: "Aide non trouvée.",
                buttons: {
                    close: "Fermer",
                },
            },
        },
    },
};
</script>

<style lang="scss">
// Specific styles for help modal if needed
</style>
